// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('[data-mobile-slider-arrows]').forEach(section => {
//     const slider = section.querySelector('.grid--mobile-slider');
//     const prev = section.querySelector('[data-mobile-prev]');
//     const next = section.querySelector('[data-mobile-next]');

//     if (!slider || !prev || !next) return;

//     const scrollAmount = () => slider.clientWidth * 0.9;

//     prev.addEventListener('click', () => {
//       slider.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
//     });

//     next.addEventListener('click', () => {
//       slider.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
//     });
//   });
// });


const updateArrowState = (slider, prev, next) => {
  const maxScroll = slider.scrollWidth - slider.clientWidth;
  const tolerance = 10; // fixes Broadcast padding/gap issue

  prev.disabled = slider.scrollLeft <= tolerance;
  next.disabled = slider.scrollLeft >= maxScroll - tolerance;
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mobile-slider-arrows]').forEach(section => {
    const slider = section.querySelector('.grid--mobile-slider');
    const prev = section.querySelector('[data-mobile-prev]');
    const next = section.querySelector('[data-mobile-next]');

    if (!slider || !prev || !next) return;

    const scrollAmount = () => slider.clientWidth * 0.9;

    // 🔥 FIX: sync arrows on load (after layout)
    requestAnimationFrame(() => {
      updateArrowState(slider, prev, next);
    });

    slider.addEventListener('scroll', () => {
      updateArrowState(slider, prev, next);
    });

    prev.addEventListener('click', () => {
      slider.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      slider.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  });
});
